import React, { PureComponent } from 'react';
import FileUploadContainer from '../../upload/components/file-upload-container';
import {applicationHistory} from '../../common/application-history';
import '../style/snapfish.scss';

export default class SnapfishUploadView extends PureComponent {
    render() {
        return (
            <div className="snapfish-uploader">
                <FileUploadContainer history={applicationHistory} snapfishMode={true}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/snapfish/components/snapfish-upload-view.jsx